/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#client'
import type { GetMeOptions, GetMeResponses } from '../models/GetMe'
import { client } from '#client'

/**
 * @description Who the user is and the access token to call this application’s API with, refreshed when it is about to expire. A browser that presents no session, or one whose grant has ended, is given a new guest.
 * @summary Who the user is
 * {@link /api/auth/me}
 */
export function getMe<ThrowOnError extends boolean = false>(options: Options<GetMeOptions, ThrowOnError>): Promise<RequestResult<GetMeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'GET', url: '/api/auth/me', ...config, throwOnError: config.throwOnError ?? false }) as Promise<RequestResult<GetMeResponses, ThrowOnError>>
}
